import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { gt, and } from '@ember/object/computed';
import Controller from '@ember/controller';
import PushService from 'cio/services/push';
import { alias } from '@ember/object/computed';
import { Platform, PlatformProvider } from 'cio/models/action';
import AnalyticsService from 'cio/services/analytics';

export default class IndexController extends Controller {
  @service push!: PushService;
  @service analytics!: AnalyticsService;

  @alias('push.platforms') platforms!: any;

  @computed('platforms')
  get allPlatformsFCM() {
    return this.platforms.every((platform: any) => platform.provider === 'fcm');
  }

  @gt('platforms.length', 1) hasMultiplePlatforms!: boolean;
  @and('allPlatformsFCM', 'hasMultiplePlatforms') showDisableAllPush!: boolean;

  @computed('platforms')
  get configurablePlatforms() {
    return [
      {
        name: 'iOS',
        icon: 'apple',
        configRoute: 'ios',
        enabled: this._isPlatformConfigured('ios'),
      },
      {
        name: 'Android',
        icon: 'android',
        configRoute: 'android',
        enabled: this._isPlatformConfigured('android'),
      },
    ];
  }

  _isPlatformConfigured(platform: string): boolean {
    return this.platforms.some((cfg: any) => cfg.key === platform);
  }

  @action
  disablePush() {
    this.push.disableCredential.perform('fcm');
    this.analytics.track('push', 'push_disabled', {
      platform: Platform.iOS,
      provider: PlatformProvider.FCM,
    });
    this.analytics.track('push', 'push_disabled', {
      platform: Platform.Android,
      provider: PlatformProvider.FCM,
    });
  }
}
